import { motion } from "framer-motion";
import { createUseStyles } from "react-jss";
import { QuestionsRawType } from "types";

type SectionHeaderType = {
  section: Pick<QuestionsRawType, "sectionTitle">;
  currentPercentage: number;
  nextPercentage: number;
};

export const SectionHeader: React.FC<SectionHeaderType> = ({
  section,
  currentPercentage,
  nextPercentage,
}) => {
  const classes = useStyles();

  return (
    <div>
      <h2 className={`text-start ${classes.surveyTitle}`}>
        {section.sectionTitle}
      </h2>

      <div className={classes.progressBarContainer}>
        <motion.div
          className={classes.progressBar}
          initial={{ width: `${currentPercentage}%` }}
          animate={{ width: `${nextPercentage}%` }}
          transition={{
            duration: 0.5,
            delay: 0.8,
            ease: "easeInOut",
          }}
        />
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  surveyTitle: {
    marginTop: 40,
    fontSize: 22,
  },
  progressBarContainer: {
    height: 10,
    width: "100%",
    backgroundColor: "#e0e0e0",
    borderRadius: 5,
    overflow: "hidden",
    marginTop: 10,
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#404254",
    borderRadius: 5,
  },
});
